import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const ReputationManagementArticle = () => {
  useSEO({
    title: 'NYC Reputation Management | SEO Review & Brand Strategy',
    description: 'Expert online reputation management in New York City. We help NYC businesses improve their review profiles, brand sentiment, and local trust.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Brand Integrity" 
            title="NYC Online Reputation Management (ORM)" 
          />
        </AnimatedSection>
        
        <div className="prose prose-invert prose-lg max-w-none text-slate-300 space-y-8">
          <p className="text-xl text-white font-medium leading-relaxed">
            In New York, your reputation is everything. A single string of negative reviews can tank your conversion rate and drop your local map rankings overnight.
          </p>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Reviews as a Ranking Factor</h3>
            <p>
              Google uses review velocity, sentiment, and diversity as a core signal for local rankings. We help you build a sustainable system for generating authentic, positive feedback from your NYC clientele.
            </p>
          </section>

          <div className="grid md:grid-cols-3 gap-4 my-10">
            <div className="bg-slate-950 p-6 rounded-xl border border-slate-800 text-center">
              <div className="text-2xl font-bold text-blue-500 mb-1">Audit</div>
              <p className="text-xs text-slate-400">Identifying brand risks across the web.</p>
            </div>
            <div className="bg-slate-950 p-6 rounded-xl border border-slate-800 text-center">
              <div className="text-2xl font-bold text-blue-500 mb-1">Suppress</div>
              <p className="text-xs text-slate-400">Pushing down negative content with SEO assets.</p>
            </div>
            <div className="bg-slate-950 p-6 rounded-xl border border-slate-800 text-center">
              <div className="text-2xl font-bold text-blue-500 mb-1">Monitor</div>
              <p className="text-xs text-slate-400">24/7 brand sentiment tracking.</p>
            </div>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Proactive Brand Protection</h3>
            <p>
              We don't just react to problems; we build a "search moat" around your brand. By optimizing your social profiles, press releases, and third-party interviews, we ensure that you control the first page of search results for your brand name.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReputationManagementArticle;